<div class="bloc-content-body">
    Votre IBAN ou votre carte bancaire est enregistré(e) uniquement pour permettre le prélèvement automatique du service et éviter toute action manuelle de votre part.
    <br/><br/>
    @if (!hasSelectedCard) {
        <div class="bloc-input civility">
            <div class="grid">
                <label for="radioIban">
                    <input id="radioIban" type="radio" name="paymentMethod" value="iban"
                           [checked]="selectedPaymentMethod == 'iban'" (click)="setSelectedPaymentMethod('iban')"/>
                    Enregistrer mon Iban/Bic
                </label>
                <label for="radioCb">
                    <input id="radioCb" type="radio" name="paymentMethod" value="cb"
                           [checked]="selectedPaymentMethod == 'cb'" (click)="setSelectedPaymentMethod('cb')"/>
                    Enregistrer ma CB
                </label>
            </div>
        </div>
    }
    @if (selectedPaymentMethod == 'iban' && form) {
        <form class="form w-100" [formGroup]="form" (ngSubmit)="submit()">
            <div class="bloc-input">
                <label for="iban">IBAN</label>
                <input
                        type="text"
                        id="iban"
                        name="iban"
                        formControlName="iban"
                        placeholder="Votre iBan"
                />
                @if (formSubmitted && getError('iban')) {
                    <small class="error-message">
                        {{ getError('iban') }}
                    </small>
                }
            </div>
            <div class="bloc-input">
                <label for="bic">BIC</label>
                <input
                        type="text"
                        id="bic"
                        name="bic"
                        formControlName="bic"
                        placeholder="BIC"
                />
                @if (formSubmitted && getError('bic')) {
                    <small class="error-message">
                        {{ getError('bic') }}
                    </small>
                }
            </div>
            <div class="bloc-input civility">
                <div class="grid">
                    <label for="authorisation">
                        <input id="authorisation" type="checkbox" [checked]="genSepa"
                               (click)="setSepa($event)" style="height: 26px !important;"/>
                        En cochant j'accepte la génération de mandat sepa
                    </label>
                </div>
            </div>
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
                </div>
            </div>
        </form>
    }
    @if (selectedPaymentMethod === 'cb' && paymentDetailsInterface) {
        <div class="col-12 mb-3">
            <div class="row w-100 pt-3 mb-3">
                <div>
                    Lors de l'enregistrement d'une carte bancaire, <span class="bold-text">un paiement de 1 €</span> est
                    demandé pour vérifier les coordonnées et valider l'enregistrement.
                    <br/><span class="bold-text">La somme réglée sera déduite de la prochaine facture.</span>
                </div>
            </div>
            <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
            <div class="row w-100 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="button" class="cta_btn level_2 column" (click)="goNexStep()">Suivant<span></span>
                    </button>
                </div>
            </div>
        </div>
    }
</div>
